import { IDatasource, IDatasourceReportFn } from 'core-ts-types';
import { Account, IAccount, IAccountAPI } from '../builders/account_builder';
import { AccountServant } from '../servants/account_servant';
import { ILocalDatabase } from 'utility-ts-database';

export class AccountDatasource {
  private _account: Account;

  constructor(private ngAccountServant: AccountServant, private localDatabase: ILocalDatabase) {
    this.initialize();
  }

  initialize(): AccountDatasource {
    this._account = this.ngAccountServant.createInvalid();
    return this;
  }

  save(): Promise<AccountDatasource> {
    return this.localDatabase.ready().then(() => {
      return this.localDatabase.put(this._account).then((account: Account) => {
        return this.write(account);
      });
    });
  }

  restore(): Promise<AccountDatasource> {
    return this.localDatabase.ready().then(() => {
      return this.localDatabase.get(this._account.id).then((account: Account) => {
        // FIXME this is terrible. what is the best way to handle this property?
        return this.write(account, { isAnonymous: account.isAnonymous });
      });
    });
  }

  reset(): Promise<ILocalDatabase> {
    this._account = this.ngAccountServant.createInvalid();

    return this.localDatabase.ready().then(() => {
      return this.localDatabase.clear();
    });
  }

  write(source: IAccount, config = { isAnonymous: true }): Promise<AccountDatasource> {
    // FIXME get rid of this configuration object
    this._account = config.isAnonymous
      ? this.ngAccountServant.createAnonymous(source)
      : this.ngAccountServant.createIdentified(source);

    return this.localDatabase.ready().then(() => {
      this.localDatabase.put(this._account);
      return this;
    });
  }

  updateExpireTime(expire_time: number): AccountDatasource {
    this._account.expire_time = expire_time;
    this.localDatabase.ready().then(() => {
      return this.localDatabase.put(this._account);
    });
    return this;
  }

  read(): Account {
    return this._account;
  }

  get account(): Account {
    return this._account;
  }

  refresh(fn: IDatasourceReportFn): AccountDatasource {
    this._account = fn(this._account);
    return this;
  }

  report(fn: IDatasourceReportFn): any {
    return fn(this._account);
  }

  isAnonymous(): boolean {
    return this._account.isAnonymous;
  }

  isSessionOpen(): boolean {
    return !_.isUndefined(this._account.token);
  }
}

angular.module('capability-ng-user-app').service('ngAccountDatasource', AccountDatasource);



// WEBPACK FOOTER //
// ./app/lib/user_app/datasources/account_datasource.ts